import axios from 'axios';
import {
	GROUP_REQUEST_GET,
	GROUP_RESPONSE_GET_SUCCESS,
	GROUP_RESPONSE_GET_FAIL,
	GROUP_REQUEST_POST,
	GROUP_RESPONSE_POST_FAIL,
	ADD_GROUP_RESPONSE_SUCCESS,
	// GROUP_REQUEST_PUT,
	GROUP_RESPONSE_PUT_FAIL,
	DELETE_GROUP_RESPONSE_SUCCESS,
	GROUP_REQUEST_UPDATE,
	GROUP_RESPONSE_UPDATE_FAIL,
	GROUP_RESPONSE_UPDATE_SUCCESS,
	BULK_GROUP_REQUEST_POST,
	BULK_ADD_GROUP_RESPONSE_SUCCESS,
	BULK_GROUP_RESPONSE_POST_FAIL,
	GROUP_REQUEST_BY_SITE_GET,
	GROUP_RESPONSE_BY_SITE_GET_FAIL,
	GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
	GROUP_REQUEST_GET_HOME_ADD,
	GROUP_RESPONSE_GET_SUCCESS_HOME_ADD,
	GROUP_RESPONSE_GET_FAIL_HOME_ADD,
	GET_COUNTRY_CODE,
	GET_COUNTRY_CODE_FAIL,
	GET_COUNTRY_CODE_SUCCESS,
	GROUP_REQUEST_CLONE,
	GROUP_RESPONSE_CLONE_SUCCESS,
	GROUP_RESPONSE_CLONE_FAIL,
	RESET_CLONE_GROUP_SUCCESS_MESSAGE,
	GROUP_REQUEST_EXPORT,
	GROUP_RESPONSE_EXPORT_SUCCESS,
	GROUP_RESPONSE_EXPORT_FAIL,
	GROUP_REQUEST_IMPORT,
	GROUP_RESPONSE_IMPORT_SUCCESS,
	GROUP_RESPONSE_IMPORT_FAIL,
	TOPOLOGY_REQUEST_GET,
	TOPOLOGY_REQUEST_GET_SUCCESS,
	TOPOLOGY_REQUEST_GET_FAIL,
	RESET_TOPOLOGY_SITES,
	GROUP_COUNTRY_REQUEST_BY_SITE_GET,
	GROUP_COUNTRY_RESPONSE_BY_SITE_GET_SUCCESS,
	GROUP_COUNTRY_RESPONSE_BY_SITE_GET_FAIL,
	LITE_TOPOLOGY_REQUEST_GET,
	LITE_TOPOLOGY_REQUEST_GET_SUCCESS,
	LITE_TOPOLOGY_REQUEST_GET_FAIL,
	GROUP_CHILD_REQUEST,
	GROUP_CHILD_RESPONSE_SUCCESS,
	GROUP_CHILD_RESPONSE_FAIL,
	INITIAL_SITE_ID,
} from '../constants/groupConstants';

import {
	ENDPOINT_URL,
	GET_GROUP_LIST,
	TOKEN_FAILED,
	API_RESPONSE_SUCCESS_STATUS_CODE,
	AUTH_TOKEN_ERROR_STATUS_CODE,
	// AUTH_TOKEN_ERROR_STATUS_MSG,
	POST_API_RESPONSE_SUCCESS_STATUS_CODE,
	API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS,
	DELETE_GROUP,
	BAD_REQUEST_ERROR_CODE,
	UPDATE_GROUP_API,
	GET_GROUP_LIST_BY_SITE,
	GET_GROUP_LIST_BY_SITE_SEARCH,
	GET_COUNTRY_CODE_API,
	POST_CLONE_GROUP,
	POST_EXPORT_GROUP,
	POST_IMPORT_GROUP,
	GET_LITE_SITE_LIST,
	API_SUCCESS_CODES,
	GET_TIP_COUNTRY_CODE_API,
} from '../constants/commonConstants';

import { logout } from './userActions';
import { decryptData, encryptData } from '../utils/crypto';
import {
	notifyAddToAprecom,
	getGroupCongigAndUpdateAprecom,
	notifyDeleteToAprecom,
	notifyBulkAddSiteToAprecomApi,
	notifyCloneSiteToAprecom
} from './apiToNotifyAprecom';
/**
 * Action creator for listing groups.
 *
 * This function asynchronously dispatches actions to fetch a list of groups.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {number} [limit=50] - Optional parameter specifying the maximum number of groups to fetch.
 * @param {number} [offset=0] - Optional parameter specifying the page no. to fetch the entries from that particular page.
 * @param {number} [search] - Optional parameter to get the list with statifies a specific seach conditions.
 * @param {object} [filters] - Optional parameter to get the list with statifies a specific filter conditions.
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const listGroup =
	(limit = 50, offset = 0, search, filters) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GROUP_REQUEST_GET,
			});
			dispatch({
				type: TOPOLOGY_REQUEST_GET,
			});

			let url =
				ENDPOINT_URL +
				GET_GROUP_LIST +
				'?limit=' +
				limit +
				'&offset=' +
				offset;

			if (search) {
				url = url + '&search=' + search;
			}
			if (filters) {
				if (filters.is_tip) {
					url = url + '&is_tip=' + filters.is_tip;
				}
				if (filters.rd) {
					url = url + '&rd=' + filters.rd;
				}
			}

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (
				data &&
				data.status &&
				data.status === API_RESPONSE_SUCCESS_STATUS_CODE
			) {
				console.log('pageNo', data);
				dispatch({
					type: GROUP_RESPONSE_GET_SUCCESS,
					payload: data,
				});

				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GROUP_RESPONSE_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: GROUP_RESPONSE_GET_FAIL,
				payload: message,
			});
		}
	};

export const listGroupTopology =
	(limit = 50, offset = 0, search) =>
	async (dispatch, getState) => {
		console.log('in list group topology');
		try {
			dispatch({
				type: TOPOLOGY_REQUEST_GET,
			});
			if (offset === 0) {
				await dispatch({ type: RESET_TOPOLOGY_SITES });
			}

			let url =
				ENDPOINT_URL +
				GET_GROUP_LIST +
				'?limit=' +
				limit +
				'&offset=' +
				offset;

			if (search) {
				url = url + '&search=' + search;
			}

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('in list group topology', data);

			if (
				data &&
				data.status &&
				data.status === API_RESPONSE_SUCCESS_STATUS_CODE
			) {
				console.log('pageNo', data);
				dispatch({
					type: TOPOLOGY_REQUEST_GET_SUCCESS,
					payload: data,
				});

				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: TOPOLOGY_REQUEST_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: TOPOLOGY_REQUEST_GET_FAIL,
				payload: message,
			});
		}
	};
export const listGroupHomeAdd =
	(limit = 50, offset = 0, search) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GROUP_REQUEST_GET_HOME_ADD,
			});

			let url =
				ENDPOINT_URL +
				GET_GROUP_LIST +
				'?limit=' +
				limit +
				'&offset=' +
				offset;

			if (search) {
				url = url + '&search=' + search;
			}

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (
				data &&
				data.status &&
				data.status === API_RESPONSE_SUCCESS_STATUS_CODE
			) {
				dispatch({
					type: GROUP_RESPONSE_GET_SUCCESS_HOME_ADD,
					payload: data,
				});
				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GROUP_RESPONSE_GET_FAIL_HOME_ADD,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: GROUP_RESPONSE_GET_FAIL_HOME_ADD,
				payload: message,
			});
		}
	};

export const listGroupBySite = (siteId) => async (dispatch, getState) => {
	try {
		dispatch({
			type: GROUP_REQUEST_BY_SITE_GET,
		});

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_GROUP_LIST_BY_SITE + siteId,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data for group by site', data);
		let existingGroups = getState().groupListBySiteReducer.groupListBySite;
		if (existingGroups && existingGroups.length > 0) {
			// Convert existingGroups to a map for faster lookup
			const existingGroupsMap = new Map(
				existingGroups.map((group) => [group.site_id, group])
			);

			// Iterate over the new data
			data.forEach((group) => {
				// If the site_id already exists, replace the existing group with the new one
				if (existingGroupsMap.has(group.site_id)) {
					existingGroupsMap.set(group.site_id, group);
				} else {
					// If it doesn't exist, add the new group
					existingGroupsMap.set(group.site_id, group);
				}
			});

			// Convert the map back to an array
			existingGroups = Array.from(existingGroupsMap.values());
		} else {
			existingGroups = [...data];
		}

		if (data && data.length > 0) {
			// dispatch({
			// 	type: GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
			// 	payload: data,
			// });
			dispatch({
				type: GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
				payload: existingGroups, // Pass the updated tree
			});
		} else if (siteId === INITIAL_SITE_ID && data && data.length === 0) {
			dispatch({
				type: GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
				payload: [],
			});
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GROUP_RESPONSE_BY_SITE_GET_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GROUP_RESPONSE_BY_SITE_GET_FAIL,
			payload: message,
		});
	}
};
export const groupCountrylistBySite =
	(siteId) => async (dispatch, getState) => {
		try {
			dispatch({
				type: GROUP_COUNTRY_REQUEST_BY_SITE_GET,
			});

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + GET_GROUP_LIST_BY_SITE + siteId,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('data for group by site', data);

			if (data && data.length > 0) {
				// dispatch({
				// 	type: GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
				// 	payload: data,
				// });
				dispatch({
					type: GROUP_COUNTRY_RESPONSE_BY_SITE_GET_SUCCESS,
					payload: data, // Pass the updated tree
				});
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GROUP_COUNTRY_RESPONSE_BY_SITE_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: GROUP_RESPONSE_BY_SITE_GET_FAIL,
				payload: message,
			});
		}
	};

export const listGroupChildBySite = (parentId) => async (dispatch, getState) => {
	try {
		dispatch({ type: GROUP_CHILD_REQUEST });


		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_GROUP_LIST_BY_SITE + parentId,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log("data111: ", data)

		dispatch({
			type: GROUP_CHILD_RESPONSE_SUCCESS,
			payload: { parentId, children: Array.isArray(data) ? data : [] },
		});
	} catch (error) {
		dispatch({
			type: GROUP_CHILD_RESPONSE_FAIL,
			payload: error.message,
		});
	}
};

export const getChildrenSites = (siteId, viewMode, offset = 0, limit = 50, searchValue) => async (dispatch, getState) => {
	try {
		let url =
			ENDPOINT_URL +
			GET_GROUP_LIST_BY_SITE +
			siteId;

		if (viewMode) {
			const query = [];
			if (offset !== undefined) query.push(`offset=${offset}`);
			if (limit !== undefined) query.push(`limit=${limit}`);
			query.push(`view_mode=${viewMode}`);

			url += `?${query.join('&')}`;
		}
		
		if (searchValue) {
			url += (url.includes('?') ? '&' : '?') + `search=${searchValue}`;
		}

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data for group by site', data);

		if (viewMode) {
			if (data && data.results) {
				return data; 
			}
		} else {
			if (data && data.length > 0) {
				return data;
			}
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			// dispatch({
			// 	type: GROUP_RESPONSE_BY_SITE_GET_FAIL,
			// 	payload: TOKEN_FAILED,
			// });
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		return message;
		// dispatch({
		// 	type: GROUP_RESPONSE_BY_SITE_GET_FAIL,
		// 	payload: message,
		// });
	}
};
export const searchGroupBySite =
	(searchValue, expanded = false) => async (dispatch, getState) => {
		try {
			dispatch({
				type: GROUP_REQUEST_BY_SITE_GET,
			});

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + GET_GROUP_LIST_BY_SITE_SEARCH + searchValue + `?expanded=${expanded}`,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString)?.filter(
				(group) => Object.keys(group).length > 0
			);

			if (data) {
				console.log('data', data);
				// dispatch({
				// 	type: GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
				// 	payload: data,
				// });
				dispatch({
					type: GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
					payload: data, // Pass the updated tree
				});
				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GROUP_RESPONSE_BY_SITE_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: GROUP_RESPONSE_BY_SITE_GET_FAIL,
				payload: message,
			});
		}
	};

export const addGroup = (payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: GROUP_REQUEST_POST,
		});

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'post',
			maxBodyLength: Infinity,
		url: ENDPOINT_URL + GET_GROUP_LIST,
		data: ciphertext,
	};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.status &&
			data.status === POST_API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			// calling group list api
			console.log('inside-----------inside', data.status);
			dispatch({
				type: ADD_GROUP_RESPONSE_SUCCESS,
				payload: { msg: data.msg, data: data.data, dataStatus: data },
			});
			dispatch(listGroup());
			dispatch(listGroupBySite(data?.data?.parent_id));
			dispatch(notifyAddToAprecom(data.data));
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GROUP_RESPONSE_POST_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			data.status === API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS &&
			data.error
		) {
			dispatch({
				type: GROUP_RESPONSE_POST_FAIL,
				payload: data.error,
			});
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GROUP_RESPONSE_POST_FAIL,
			payload: message,
		});
	}
};

export const bulkAddGroup = (payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: BULK_GROUP_REQUEST_POST,
		});

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'post',
		url: ENDPOINT_URL + GET_GROUP_LIST,
		data: ciphertext,
	};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('bulkAddGroup', payload, data.data);
		if (data && data.data && API_SUCCESS_CODES.includes(data.status)) {
			// calling group list api
			console.log('inside-----------inside');
			dispatch({
				type: BULK_ADD_GROUP_RESPONSE_SUCCESS,
				payload: { data: data.data },
				msg: data?.msg,
			});
			if (payload) {
				dispatch(notifyBulkAddSiteToAprecomApi(payload));
			}
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: BULK_GROUP_RESPONSE_POST_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			data.status === API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS &&
			data.error
		) {
			dispatch({
				type: BULK_GROUP_RESPONSE_POST_FAIL,
				payload: data.error,
			});
			return data;
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: BULK_GROUP_RESPONSE_POST_FAIL,
			payload: message,
		});
	}
};

export const deleteGroup =
	(payload, selectAllOption) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			// dispatch({
			// 	type: GROUP_REQUEST_PUT,
			// });

			const jsonData = JSON.stringify(payload);
			const ciphertext = encryptData(jsonData);
			let url = ENDPOINT_URL + DELETE_GROUP;
			if (selectAllOption) {
				url = ENDPOINT_URL + DELETE_GROUP + '?selectall=true';
			}

			// Configure request
			const config = {
				method: 'put',
			url: url,
			data: ciphertext,
		};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			if (data && data.data && API_SUCCESS_CODES.includes(data.status)) {
				dispatch({
					type: DELETE_GROUP_RESPONSE_SUCCESS,
					payload: {
						successMessageOnDelete: data.msg,
						data: data.data,
						dataStatus: data.status},
				});
				dispatch(listGroup());
				if (
					data?.data?.aprecommpayload &&
					Array.isArray(data?.data?.aprecommpayload)
				) {
					dispatch(
						notifyDeleteToAprecom({
							siteList: data.data.aprecommpayload.map((obj) => {
								return { siteName: obj };
							}),
						})
					);
				}
			} else if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GROUP_RESPONSE_PUT_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			} else if (
				data &&
				data.status &&
				data.status === BAD_REQUEST_ERROR_CODE &&
				data.error
			) {
				if (
					data.error.hasOwnProperty('SITE_CANNOT_BE_DELETED') ||
					data.error.hasOwnProperty(
						'SITE_CANNOT_BE_DELETED_AS_IT_CONSISTS_OF_DEVICES'
					)
				) {
					// const errorMessage =
					// 	'AP is linked to the Site, so cannot be deleted.';
					const errorMessage =
						'SITE_CANNOT_BE_DELETED_AS_IT_CONSISTS_OF_DEVICES';
					dispatch({
						type: GROUP_RESPONSE_PUT_FAIL,
						payload: errorMessage,
					});
				} else {
					dispatch({
						type: GROUP_RESPONSE_PUT_FAIL,
						payload: data.error,
					});
				}
				dispatch(listGroup());
			}
			return data;
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: GROUP_RESPONSE_PUT_FAIL,
				payload: message,
			});
		}
	};

/**
 * Action for making an API call to update the group info.
 *
 * @param {object} updatePayload - Object contains site-name,sap_id,site_location and description
 * @param {string} siteID - Object contains site-name,sap_id,site_location and description
 * @return {Promise} - A promise that resolves with the deleted ssid data.
 */
export const updateGroupeName =
	(updatePayload, siteID) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: GROUP_REQUEST_UPDATE,
			});

			const jsonData = JSON.stringify(updatePayload);
			const ciphertext = encryptData(jsonData);

			// Configure request
		const config = {
			method: 'patch',
			url: ENDPOINT_URL + UPDATE_GROUP_API + siteID + '/',
			data: ciphertext,
		};

			// Send request and get response
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('updateGroupeName', data);
			// Dispatch success action with received data
			dispatch({
				type: GROUP_RESPONSE_UPDATE_SUCCESS,
				payload: data,
			});
			// get new nestedSiteName and call update aprecom api
			if (updatePayload?.oldNestedSiteName) {
				dispatch(
					getGroupCongigAndUpdateAprecom({
						oldNestedSiteName: updatePayload?.oldNestedSiteName,
						siteId: siteID,
					})
				);
			}
			return data;
		} catch (error) {
			// Handle error
			console.error('Failed to update site name:', error);
			dispatch({
				type: GROUP_RESPONSE_UPDATE_FAIL,
				payload: error.message || 'Failed to update site name',
			});
			return error;
		}
	};

export const listCountryCodes = () => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_COUNTRY_CODE,
		});

		const url = ENDPOINT_URL + GET_COUNTRY_CODE_API;

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.status &&
			data.status === API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			dispatch({
				type: GET_COUNTRY_CODE_SUCCESS,
				payload: data,
			});
			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_COUNTRY_CODE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GROUP_RESPONSE_GET_FAIL,
			payload: message,
		});
	}
};

export const listTipCountryCodes = () => async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_COUNTRY_CODE,
		});

		const url = ENDPOINT_URL + GET_TIP_COUNTRY_CODE_API;

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.status &&
			data.status === API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			dispatch({
				type: GET_COUNTRY_CODE_SUCCESS,
				payload: data,
			});
			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GET_COUNTRY_CODE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: GROUP_RESPONSE_GET_FAIL,
			payload: message,
		});
	}
};

/**
 * Action creator for cloning a group.
 *
 * This function dispatches actions to manage the clone group process.
 * Upon success, the newly cloned group data is dispatched.
 * Handles token expiry by logging out if needed.
 *
 * @param {Object} payload - Data required to clone a group
 * @param {string} payload.clone_parent_id - ID of the parent group being cloned
 * @param {string} payload.site_name - Name of the cloned group
 * @param {string} payload.sap_id - SAP ID for the cloned group
 * @param {string} payload.site_location - Location of the cloned group
 * @param {string} payload.country - Country of the cloned group
 * @param {string} [payload.description] - Optional description for the group
 * @param {boolean} payload.is_clone_for_tip - Whether the group is TIP-enabled
 * @return {function} Dispatch function for asynchronous operations
 */
export const cloneGroup = (payload) => async (dispatch, getState) => {
	try {
		dispatch({ type: GROUP_REQUEST_CLONE });

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		const config = {
		method: 'post',
		url: ENDPOINT_URL + POST_CLONE_GROUP,
		data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if (data && data.status && API_SUCCESS_CODES?.includes(data?.status)) {
			dispatch({
				type: GROUP_RESPONSE_CLONE_SUCCESS,
				payload: { msg: data.msg, data: data.data },
			});
			// Clone succeeded => notify 3rd party (aprecom) after clone.
			// Do not fail the clone flow if aprecom notification fails.
			try {
				await dispatch(notifyCloneSiteToAprecom(data.data));
			} catch (aprecomError) {
				console.log('aprecom notify after clone failed', aprecomError);
			}
			return { success: true, ...data }; // Return the data explicitly
		}

		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: GROUP_RESPONSE_CLONE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
			return { success: false, error: TOKEN_FAILED }; // Handle logout response
		} else {
			dispatch({ type: GROUP_RESPONSE_CLONE_FAIL, payload: data.error });
			return { success: false, error: data.error }; // Return error response
		}
	} catch (error) {
		let message = "An error occurred while cloning the Site.";
		try {
			if (error.response && error.response.data) {
				const decrypted = decryptData(error.response.data);
				const parsed = JSON.parse(decrypted);

				message = parsed.error || parsed.msg || message;
			} else {
				message = error.message;
			}
		} catch (decryptErr) {
			console.log('Error decrypting error response', decryptErr);
			message = error.message;
		}


		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}

		dispatch({ type: GROUP_RESPONSE_CLONE_FAIL, payload: message });
		return { success: false, error: message }; // Ensure errors are returned
	}
};

/**
 * Action creator to reset the clone group success message or error.
 *
 * @return {Function} A thunk function that dispatches an action to reset the clone group success message or error.
 */
export const resetCloneGroupSuccessMessage = () => (dispatch) => {
	dispatch({ type: RESET_CLONE_GROUP_SUCCESS_MESSAGE });
};

/**
 * Action creator for exporting site configurations.
 *
 * This function handles the API call to export configurations for a specific site
 * and triggers a file download of the encrypted response.
 *
 * @param {string} siteId - The ID of the site for which configurations need to be exported
 * @return {function} Dispatch function for asynchronous operations
 */
export const exportSiteConfiguration =
	(siteId) => async (dispatch, getState) => {
		console.log('AyushSSS');
		try {
			dispatch({ type: GROUP_REQUEST_EXPORT });

		const config = {
			method: 'post',
			url: `${ENDPOINT_URL}${POST_EXPORT_GROUP}${siteId}/`,
			responseType: 'blob', // Expecting a binary response
			};

			const { data, headers } = await axios.request(config);

			const contentDisposition = headers['content-disposition'];
			const filename = contentDisposition
				? contentDisposition.split('filename=')[1].replace(/"/g, '')
				: 'site_configuration.txt';

			// Create a Blob from the response and trigger download
			const blob = new Blob([data], { type: 'text/plain' });
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			dispatch({ type: GROUP_RESPONSE_EXPORT_SUCCESS });
			return { success: true };
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;

			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}

			dispatch({ type: GROUP_RESPONSE_EXPORT_FAIL, payload: message });
			return { success: false, error: message };
		}
	};

/**
 * Action creator for importing site configurations.
 *
 * This function handles the API call to import configurations for a specific site.
 * It sends the configuration file as part of the request body and processes the server response.
 * Updates the Redux store with the request status.
 *
 * @param {string} siteId - The ID of the site for which configurations need to be imported.
 * @param {File} file - The configuration file to be imported (expected to be a text file).
 * @return {function} Dispatch function for asynchronous operations.
 */
export const importSiteConfiguration =
	(siteId, file) => async (dispatch, getState) => {
		try {
			dispatch({ type: GROUP_REQUEST_IMPORT });

			const formData = new FormData();
			formData.append('config_file', file);

		const config = {
			method: 'post',
			url: `${ENDPOINT_URL}${POST_IMPORT_GROUP}${siteId}/`,
				data: formData,
			};

			const { data } = await axios.request(config);
			const decryptedResponse = JSON.parse(decryptData(data)); // Decrypt the encrypted response

			if (
				decryptedResponse &&
				decryptedResponse.status &&
				API_SUCCESS_CODES?.includes(decryptedResponse?.status)
			) {
				dispatch({
					type: GROUP_RESPONSE_IMPORT_SUCCESS,
					payload: decryptedResponse,
				});
				return { success: true, message: decryptedResponse.msg };
			} else {
				const errorMessage =
					decryptedResponse?.msg ||
					decryptedResponse?.error ||
					decryptedResponse?.message ||
					'Failed to import configuration.';
				dispatch({
					type: GROUP_RESPONSE_IMPORT_FAIL,
					payload: errorMessage,
				});
				return { success: false, message: String(errorMessage).trim() };
			}
		} catch (error) {
			let message = 'An error occurred during import.';
			try {
				if (error.response && error.response.data) {
					const raw = error.response.data;
					let parsed = raw;
					if (typeof raw === 'string') {
						try {
							parsed = JSON.parse(decryptData(raw));
						} catch (_) {
							try {
								parsed = JSON.parse(raw);
							} catch (__) {
								parsed = { msg: raw };
							}
						}
					} else if (raw && typeof raw === 'object') {
						// Some gateways return encrypted payload as a field, others plain JSON.
						if (typeof raw.data === 'string' && !raw.msg && !raw.message) {
							try {
								parsed = JSON.parse(decryptData(raw.data));
							} catch (_) {
								parsed = raw;
							}
						}
					}
					message =
						parsed?.msg ||
						parsed?.error ||
						parsed?.message ||
						message;
				} else if (error.message) {
					message = error.message;
				}
			} catch (parseErr) {
				message =
					error.response?.data?.msg ||
					error.response?.data?.message ||
					error.message ||
					message;
			}

			message = String(message).trim();

			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}

			dispatch({ type: GROUP_RESPONSE_IMPORT_FAIL, payload: message });
			return { success: false, message };
		}
	};

export const listLiteTopology = (isTip = null) => async (dispatch, getState) => {
	console.log('in list group topology');
	try {
		dispatch({
			type: LITE_TOPOLOGY_REQUEST_GET,
		});

		let url = ENDPOINT_URL + GET_LITE_SITE_LIST;

		if(isTip !== null){
			url += "?is_tip=" + isTip;
		}

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('in list group topology.....', data);

		if (data && data.status && API_SUCCESS_CODES?.includes(data?.status)) {
			console.log('pageNo', data);
			dispatch({
				type: LITE_TOPOLOGY_REQUEST_GET_SUCCESS,
				payload: data,
			});

			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: LITE_TOPOLOGY_REQUEST_GET_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
			return data;
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: LITE_TOPOLOGY_REQUEST_GET_FAIL,
			payload: message,
		});
		return error;
	}
};
